var _animateTransform, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefreshLoading({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1731406690923,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 26635,
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _animateTransform || (_animateTransform = /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    attributeType: "XML",
    type: "rotate",
    from: "0 0 0",
    to: "360 0 0",
    dur: "0.8s",
    repeatCount: "indefinite"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M936.571429 603.428571q0 2.857143-0.571429 4-36.571429 153.142857-153.142857 248.285714t-273.142857 95.142857q-83.428571 0-161.428571-31.428571t-139.142857-89.714286l-73.714286 73.714286q-10.857143 10.857143-25.714286 10.857143t-25.714286-10.857143-10.857143-25.714286l0-256q0-14.857143 10.857143-25.714286t25.714286-10.857143l256 0q14.857143 0 25.714286 10.857143t10.857143 25.714286-10.857143 25.714286l-78.285714 78.285714q40.571429 37.714286 92 58.285714t106.857143 20.571429q76.571429 0 142.857143-37.142857t106.285714-102.285714q6.285714-9.714286 30.285714-66.857143 4.571429-13.142857 17.142857-13.142857l109.714286 0q7.428571 0 12.857143 5.428571t5.428571 12.857143zm14.285714-457.142857l0 256q0 14.857143-10.857143 25.714286t-25.714286 10.857143l-256 0q-14.857143 0-25.714286-10.857143t-10.857143-25.714286 10.857143-25.714286l78.857143-78.857143q-84.571429-78.285714-199.428571-78.285714-76.571429 0-142.857143 37.142857t-106.285714 102.285714q-6.285714 9.714286-30.285714 66.857143-4.571429 13.142857-17.142857 13.142857l-113.714286 0q-7.428571 0-12.857143-5.428571t-5.428571-12.857143l0-4q37.142857-153.142857 154.285714-248.285714t274.285714-95.142857q83.428571 0 162.285714 31.714286t140 89.428571l74.285714-73.714286q10.857143-10.857143 25.714286-10.857143t25.714286 10.857143 10.857143 25.714286z",
    "p-id": 26636,
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshLoading);
export default __webpack_public_path__ + "static/media/refresh-loading.8d8d3a2f65d83093e69e9a1cc7649af9.svg";
export { ForwardRef as ReactComponent };